import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
// @mui
import { useTheme } from "@mui/material/styles";
import {Avatar, Box, Link, Typography} from "@mui/material";
import { PATH_HOMEPAGE } from "../../routes/paths";
import Image from "../image";

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();


  // OR using local (public folder)
  // -------------------------------------------------------
  const logo = (
    <Box
      sx={{ cursor: "pointer", height: "auto", display: "flex", alignItems: 'center', ...sx }}
    >
      <Avatar src="/logo/logo.png" sx={{  height: 53, width: 53}} />

      <Typography component="span" sx={{fontWeight: 500, fontSize: "20px", color: '#414141', ml: 1}}>SnelNL</Typography>


    </Box>
  );



  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link
      to="/"
      rel="noopener"
      component={RouterLink}
      sx={{ display: "contents" }}
    >
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
